import { render, staticRenderFns } from "./participant-reset-password.vue?vue&type=template&id=53c685c6&scoped=true&"
import script from "./participant-reset-password.vue?vue&type=script&lang=js&"
export * from "./participant-reset-password.vue?vue&type=script&lang=js&"
import style0 from "./participant-reset-password.vue?vue&type=style&index=0&id=53c685c6&scoped=true&lang=scss&"
import style1 from "@/assets/auth-screen.scss?vue&type=style&index=1&id=53c685c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c685c6",
  null
  
)

component.options.__file = "participant-reset-password.vue"
export default component.exports